module.exports = __webpack_public_path__ + "static/Mag+Logo-155a81cfe76de59abada3dd00b840bbf.png";